var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "icon", attrs: { href: "/account/promotions" } },
    [
      _c("ui-badge", {
        attrs: { text: _vm.COUPONS_COUNT, color: "#F34744", "max-width": "50" }
      }),
      _c("f-sprite-icon", {
        attrs: { "icon-link": _vm.$options.icons.IconNotifications.id }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }